<template>
  <v-container fluid class="px-0 py-0">
    <v-sheet class="px-0 py-0">
      <CommonFieldString v-model="search" label="Search" :clearable="true"></CommonFieldString>
      <v-data-table
          :headers="headers"
          dense
          :items="value"
          class="elevation-1"
          :search="search"
          fixed-header
          :height="height"
          hide-default-footer
          :options="options"
      >
        <template v-slot:item.append="{ item }">
          <v-icon small @click="$emit('append', item)" color="edit_icon" class="d-flex justify-center">
            mdi-plus-circle-outline
          </v-icon>
        </template>
        <template v-slot:item.remove="{ item }">
          <v-icon small @click="$emit('remove', item)" color="edit_icon" class="d-flex justify-center">
            mdi-close-circle-outline
          </v-icon>
        </template>
      </v-data-table>
    </v-sheet>

  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreSpecAttrComponentDetail from "@/components/CoreComponent/SpecAttrComponent/CoreSpecAttrComponentDetail";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";
import CommonFieldString from "@/components/Common/CommonFieldString.vue";
import CommonFieldCheck from "@/components/Common/CommonFieldCheck.vue";
import CommonFieldNumber from "@/components/Common/CommonFieldNumber.vue";

export default {
  name: "CoreSubcategoryAttr",

  props: {
    value: {default: []},
    height: {default: 0},
    headers: {default: []},
  },

  components: {CommonFieldNumber, CommonFieldCheck, CommonFieldString},

  methods: {
    openEditDialog(item, index) {
      this.attr_index = index
      this.attribute = structuredClone(this.value[this.attr_index])
      this.attribute.manual_change = true
      this.dialog = true
    },

    saveDialog() {
      this.dialog = false
      this.value[this.attr_index] = structuredClone(this.attribute)
      this.$emit('input', structuredClone(this.value))
    }
  },


  mounted() {
  },

  data() {
    return {
      dialog: false,
      attr_index: 0,
      attribute: {},
      search: null,
      options: {
        itemsPerPage: -1,
      },
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>